import { getReturnTo } from "../../../shared/utils/helpers";
import { RecruiterActionRoutes } from "./routes";
import { KEY_RETURN_TO_POST_ONBOARDING } from "../../../shared/constants";

export const shouldReturnToRecruiterActions = () => {
    const returnTo = getReturnTo()
    if (!returnTo) return false
    return Object.values(RecruiterActionRoutes).includes(returnTo as any)
}

export const isFromRecruiterActionsOnboarding = () => {
    const returnToPostOnboarding = sessionStorage.getItem(
        KEY_RETURN_TO_POST_ONBOARDING
    );
    return Object.values(RecruiterActionRoutes).includes(
        returnToPostOnboarding as any
    );
}
